import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowRight } from '../components/Icons';
import usePageTitle from '../hooks/usePageTitle';
import './NotFoundPage.css';

const NotFoundPage = () => {
  usePageTitle('Page not found');
  const { pathname } = useLocation();

  return (
    <section className="not-found">
      <div className="container">
        <p className="glitch" data-text="404" aria-hidden="true">
          404
        </p>
        <h1>This page is wired a little too differently.</h1>
        <p className="lead">
          We looked everywhere for <code>{pathname}</code>, with great attention to detail, and it isn't here.
        </p>
        <div className="nf-actions">
          <Link to="/" className="btn">
            Back to home <ArrowRight />
          </Link>
          <Link to="/contact" className="btn btn-ghost">
            Report a broken link
          </Link>
        </div>
      </div>
    </section>
  );
};

export default NotFoundPage;
